import { Table } from '@repo/sanity/types'
import { cn } from '@repo/ui/lib/utils'
import { FunctionComponent } from 'react'

interface Props {
  table: Table
}

const SizeGuideTable: FunctionComponent<Props> = ({ table }) => {
  if (!table.rows) {
    return null
  }

  const [head, ...rows] = table.rows
  const isBiDirectional = head?.cells?.[0]?.length === 0
  const cellClassname = 'px-3 py-2.5'

  return (
    <div className='overflow-x-auto'>
      <table className='divide-border min-w-full divide-y text-left'>
        {head?.cells && (
          <thead className='uppercase'>
            <tr>
              {head.cells.map((cell, i) => (
                <th key={i} className={cn('bg-card font-normal', cellClassname)}>
                  {cell}
                </th>
              ))}
            </tr>
          </thead>
        )}
        <tbody className='divide-border divide-y'>
          {rows.map((row, index) => (
            <tr key={index} className='even:bg-card hover:bg-miista-neutral-100'>
              {row?.cells?.map((cell, index) => {
                const Component = isBiDirectional && index === 0 ? 'th' : 'td'

                return (
                  <Component key={index} className={cellClassname}>
                    {cell}
                  </Component>
                )
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default SizeGuideTable
